<script setup lang="ts"> 
    import { Dropdown, DropdownOptions } from 'flowbite';

    const props= defineProps({
        buttonText: {
            type: String,
            default: "",
        },
        callback: {
            type: Function,
            default(){
                return () => {}
            }
        },
        icon: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default(){
                return [] as DropdownOption[]
            }
        },
        selectedReference: {
            type: String,
            default: ""
        },
        uid: {
            type: String,
            default: ""
        }
    });

    const dropdown = ref();
    const closeDropdown = ref(() => {});

    function blurAll() {
       document.getElementById("unfocuser")?.click();
    }

    onMounted(() => {
        const $targetEl = document.getElementById(`dropdown_${props.uid}`);
        const $triggerEl = document.getElementById(`dropdownDefaultButton_${props.uid}`);
        const options = {
            placement: 'bottom',
            offsetSkidding: 0,
            offsetDistance: 10,
            onHide: () => {
                //
            },
            onShow: () => {
                //
            }
        };
        if($targetEl) {
            dropdown.value = new Dropdown($targetEl, $triggerEl, options as DropdownOptions);
            closeDropdown.value = () => {
                dropdown.value.hide();
                blurAll();
            }
        }
    });
    
</script>

<template>
    <span id="unfocuser"></span> <!-- used to remove focus on hide -->
    <button 
        :id="`dropdownDefaultButton_${props.uid}`" 
        :data-dropdown-toggle="`dropdown_${props.uid}`" 
        class="text-clive-black hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm mr-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 h-8 uppercase" 
        type="button"
        aria-label="language"
    >
        {{ buttonText }}
        <component v-if="props.icon" :is="icon" class="h-5 w-5"/>
        <svg 
            class="stroke-clive-blue w-4 h-4 ml-2" 
            aria-hidden="true" 
            fill="none" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
    </button>
    <div 
        :id="`dropdown_${props.uid}`" 
        class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
    >
        <ul 
            class="py-2 text-sm text-gray-700 dark:text-gray-200" 
            :aria-labelledby="`dropdownDefaultButton_${props.uid}`"
        >
            <li v-for="option in (options as DropdownOption[])" @click="closeDropdown(); callback(option.abbreviation)">
                <a 
                    href="#" 
                    :class="`block px-4 py-2 hover:bg-gray-100 ${selectedReference && option.abbreviation === selectedReference ? 'font-bold': ''}`"
                    :aria-label="option.label"
                >
                    {{ option.label }}
                </a>
            </li>
        </ul>
    </div>
</template>

